import * as React from 'react';
import styles from './favourite-info.scss';

interface FavouriteInfoComponentProps {
  id?: number;
  owner?: string;
  parent?: string;
}

export const FavouriteInfo: React.FC<FavouriteInfoComponentProps> = ({
  id, owner, parent
}) => (
  <div className={styles.tileInfo}>
    <ul className={styles.tileInfoContent}>
      {!!id && <li className={styles.tileId}>#{id}</li>}
      {!!owner && <li><span className="default-icon user" />{owner}</li>}
      {!!parent && <li><span className="default-icon folder-small" />{parent}</li>}
    </ul>
  </div>
);
